export function withBold(font: string, bold: boolean | undefined): string {
  if (bold === undefined) return font;

  return bold ? addBold(font) : removeBold(font);
}

export function withItalic(font: string, italic: boolean | undefined): string {
  if (italic === undefined) return font;

  return italic ? addItalic(font) : removeItalic(font);
}

// ── Add ────────────────────────────────────────────────────────────────

export function addBold(font: string): string {
  if (isBold(font)) return font;

  return `bold ${font.trim()}`;
}

export function addItalic(font: string): string {
  if (isItalic(font)) return font;

  return `italic ${font.trim()}`;
}

// ── Remove ─────────────────────────────────────────────────────────────

export function removeBold(font: string): string {
  return font
    .replace(
      /\b(bold(er)?|black|extrabold|semibold|bolder|lighter|[1-9]00)\b\s*/gi,
      ''
    )
    .replace(/\s+/g, ' ')
    .trim();
}

export function removeItalic(font: string): string {
  return font
    .replace(/\s*(italic|oblique)\s*/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

// ── Detect ─────────────────────────────────────────────────────────────

export function isBold(font: string): boolean {
  return /\b(bold(er)?|bolder|black|extrabold|semibold|[6-9]00)\b/i.test(font);
}

export function isItalic(font: string): boolean {
  return /\b(italic|oblique)\b/i.test(font);
}
